import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonAppModule } from '../../common/common-app.module';
import { CardUnlockResolvePopupComponent } from '../../products/cards/card-unlock-wizard/resolve/card-unlock-resolve-popup/card-unlock-resolve-popup.component';
import { LeftPanelModule } from '../../products/left-panel/left-panel.module';
import { AppDownloadModule } from '../../shared/app-download/app-download.module';
import { SipPhoneCallModule } from '../../shared/sip-phone-call/sip-phone-call.module';
import { SplashBannersModule } from '../../shared/splash-banners/splash-banners.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { ScrollToTopButtonComponent } from '../addition/scroll-to-top-button/scroll-to-top-button.component';
import { UiModule } from '../ui.module';

import { CardCreditGuardPopupComponent } from './../../products/cards/card-credit-create-wizard/guard/card-credit-guard-popup/card-credit-guard-popup.component';
import { CreateCardForCreditPopupComponent } from './../../products/credits/create-card-for-credit-popup/create-card-for-credit-popup.component';
import { CurrencyCourseComponent } from './footer/components/currency-course/currency-course.component';
import { FooterComponent } from './footer/footer.component';
import { GoodbyeIeModule } from './goodbye-ie/goodbye-ie.module';
import { HeaderModule } from './header/header.module';
import { LayoutComponent } from './layout.component';
import { LayoutService } from './layout.service';


@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		LeftPanelModule,
		UiModule,
		SvgCommonModule,
		SipPhoneCallModule,
		AppDownloadModule,
		GoodbyeIeModule,
		RouterModule.forChild([]),
		HeaderModule,

		SplashBannersModule,
		ScrollToTopButtonComponent,
	],
	declarations: [
		LayoutComponent,
		FooterComponent,
		CurrencyCourseComponent,
		CardCreditGuardPopupComponent,
		CreateCardForCreditPopupComponent,
		CardUnlockResolvePopupComponent,
	],
	exports: [
		FooterComponent,
		CurrencyCourseComponent,
	],
	providers: [LayoutService],
})

export class LayoutModule { }
